import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'hub-no-network',
  templateUrl: './no-network.component.html',
  styleUrls: ['./no-network.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoNetworkComponent implements OnInit {
  public searching: boolean = true;

  private _searchSub: Subscription;

  constructor(public changeRef: ChangeDetectorRef) {}

  ngOnInit() {
    this._searchSub = interval(10000).subscribe(val => {
      this.searching = val % 2 == 0;
      this.changeRef.detectChanges();
    });
  }

  ngOnDestroy() {
    if (this._searchSub) this._searchSub.unsubscribe();
  }
}
